<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.flex {
  display: flex;
}

.subtitle {
  font-size: 18px;
  font-weight: 600;
}

.bottom-20 {
    margin-bottom: 20px;
}

.bottom-30 {
    margin-bottom: 30px;
}

</style>
